import quoteGQLString from '../../util/quoteGQLString';

export default (drug) => `
    id: ${quoteGQLString(drug?.id)}
    org: ${quoteGQLString(drug?.org)}
    ndc: ${quoteGQLString(drug?.ndc)}
    description: ${quoteGQLString(drug?.description)}
    type: ${quoteGQLString(drug?.type)}
`;
